import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-variation',
  templateUrl: './variation.page.html',
  styleUrls: ['./variation.page.scss'],
})
export class VariationPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
